<template>
  <Card v-if="organization" :title="organization.name">
    <form class="form"
          enctype="multipart/form-data"
          novalidate
          @submit.prevent="() => {}">
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-model="organizationType" :label="t('organization.type')" name="type"/>
        <FormReadonlyField v-model="organization.chapter" :label="t('organization.chapter')"
                           name="chapter"/>
        <FormReadonlyField v-model="organization.enterpriseNumber"
                           :label="t('organization.enterpriseNumber')"
                           name="enterpriseNumber"/>
      </FormRow>
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-model="organization.apartment" :label="t('global.apartment')"
                           name="apartment"/>
        <FormReadonlyField v-model="organization.street" :label="t('global.street')" name="street"/>
        <FormReadonlyField v-model="organization.city" :label="t('global.city')" name="city"/>
      </FormRow>
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-model="organization.zipCode" :label="t('global.zipCode')" name="zipCode"/>
        <div class="form__duo-fields">
          <FormReadonlyField v-model="organization.phoneNumber" :label="t('global.phoneNumber')"
                             name="phoneNumber"/>
          <FormReadonlyField v-model="organization.phoneExtension" :label="t('global.phoneExtension')"
                             name="phoneExtension"/>
        </div>
        <FormReadonlyField v-model="organization.email" :label="t('global.email')" name="email"/>
      </FormRow>
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-model="organization.subscription.startAt"
                           :label="t('organization.subscriptionStartAt')"
                           name="subscriptionStartAt"/>
        <FormReadonlyField v-model="organization.subscription.endAt"
                           :label="t('organization.subscriptionEndAt')"
                           name="subscriptionEndAt"/>
        <FormReadonlyField v-model="organization.memberNumber" :label="t('organization.memberNumber')"
                           name="memberNumber"/>
      </FormRow>
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-if="organization.type !== OrganizationType.Corporate"
                           v-model="organization.numberOfUnits" :label="t('organization.numberOfUnits')"
                           name="numberOfUnits"/>
      </FormRow>
    </form>
  </Card>
</template>
<script lang="ts" setup>
import {computed, onMounted, ref} from "vue"
import {useI18n} from "vue3-i18n"
import {OrganizationType} from "@/types"
import {IFullOrganization} from "@/types/entities/organization";
import FormReadonlyField from "@/components/forms/FormReadonlyField.vue"
import Card from "@/components/layout/Card.vue"
import FormRow from "@/components/forms/FormRow.vue"
import {useOrganizationService} from "@/inversify.config";

// eslint-disable-next-line
const props = defineProps<{
  organizationId: string
}>()

const {t, getLocale} = useI18n()
const organizationService = useOrganizationService()

const organization = ref<IFullOrganization>()
const organizationIsLoading = ref(false)

onMounted(async () => {
  await loadOrganization()
})

let organizationType = computed(() => {
  if (!organization.value)
    return
  let type = organization.value.type.makeFirstLetterLowercase()
  return t(`organization.types.${type}`)
})

async function loadOrganization() {
  organizationIsLoading.value = true

  let fullOrganization = await organizationService.getMyOrganization(getLocale())
  if (fullOrganization) {
    organization.value = fullOrganization
  }
  organizationIsLoading.value = false
}
</script>